import styled from "styled-components/macro";
import Svg from "../../../Svg/Svg";


export const Root = styled.div`
    height: 100%;
    position: relative;
`;

export const SvgBase = styled(Svg)`
    height: 100%;
    user-select: none;

    svg {
        height: 100%;
        width: auto;
        display: block;
        margin: 0 auto;
        padding: 0;
    }

    path {
        cursor: pointer;
    }

    svg path:not([fill]) {
        fill: transparent;
    }
`;

export const PngMask = styled.div`
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    mix-blend-mode: revert;

    img {
        height: 100%;
        width: auto;
        display: block;
        margin: 0 auto;
        padding: 0;
    }
`;

export const Warning = styled.div``;
